module.exports = __webpack_public_path__ + "media/images/flags/gn-2f8aa6a3d90c4e52913fa76a2be2e842.svg";